import { render, staticRenderFns } from "./GoodReceiveViewItem.vue?vue&type=template&id=cdb73f9e&scoped=true&"
import script from "./GoodReceiveViewItem.vue?vue&type=script&lang=js&"
export * from "./GoodReceiveViewItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodReceiveViewItem.vue?vue&type=style&index=0&id=cdb73f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb73f9e",
  null
  
)

export default component.exports